<!--
  A view that lays GDPR confirmation request
-->
<template>
  <div>
    <div class="data_preparation__form">

      <div class="data_preparation__field has-text-weight-bold">
        <p>
          {{$t(`${pagei18nKey}.completeFormSentence`)}}
        </p>
      </div>
      <div class="data_preparation__field">
        <p>
          {{$t(`${pagei18nKey}.airportDeliverySentence`)}}
        </p>
      </div>
      <div class="data_preparation__field">
        <p>
          {{$t(`${pagei18nKey}.pleaseContinue`)}}
        </p>
      </div>
    </div>


    <!-- Navigation - back and next buttons -->    
    <div class="data_preparation__navigation_container">
      <ms-navigation-bar
        :buttons="[ backButton, nextButton ]"
        @navigationButtonClick="navigationButtonClick"
      />
    </div>


  </div>
</template>

<script>
  import MsAppMessage from '@/components/ms-app-message'
  import MsNavigationBar, {DefaultNavigationButtons} from '@/components/ms-navigation-bar'

  export default {
    name: 'DataPreparationView',
    components: {
      MsAppMessage,
      MsNavigationBar
    },

    data: function () {
      return {
        pagei18nKey: 'message.dataPreparation'
      }
    },
    methods: {
      /**
       * On navigation button clicked change view
       *
       * @param {string} buttonId - The id of the clicked button
       */
      navigationButtonClick: function (buttonId) {
        if (buttonId === DefaultNavigationButtons.BACK.id) {
          this.$router.go(-1)
        } else if (buttonId === DefaultNavigationButtons.NEXT.id) {
          this.$router.push('/make-delayed-claim')
        }
      }
    },

    computed: {
      /**
       * Get back button object
       */
      backButton: {
        get () {
          return DefaultNavigationButtons.BACK
        }
      },

      /**
       * Get next button object
       */
      nextButton: {
        get () {
          return DefaultNavigationButtons.NEXT
        }
      }

    }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/sass/main.scss";
  @import "data-preparation.scss";
</style>
